import { Button, Stack } from '@mantine/core'
import { useForm } from '@mantine/form'
import { useRouter } from 'next/router'
import React, { useState } from 'react'

import { api, errorHandler, notificationHandler } from '@/lib/utils'

interface Props {
  onCancel?: () => void
  onCallback?: () => void
  children?: React.ReactNode
}

export default function CodeNotification({ onCancel, onCallback, children }: Props) {
  // Hooks
  const router = useRouter()
  const { site: siteSlug, 'powerup-token': powerupToken } = router.query || {}

  // States
  const [loading, setLoading] = useState<boolean>(false)
  const form = useForm()

  // Actions
  const handleSubmit = async () => {
    setLoading(true)
    api
      .post(`/${siteSlug}/accounts/one-time-token/${powerupToken}/`)
      .then(() => {
        notificationHandler({
          variant: 'success',
          message: 'O código de confirmação foi enviado em seu e-mail!'
        })
      })
      .catch(error => {
        const errors = errorHandler(error?.response?.data)
        notificationHandler({
          variant: 'error',
          message: `${errors?.messages?.[0]}` || 'Erro ao enviar o código de confirmação.'
        })
      })
      .finally(() => {
        onCallback?.()
        setLoading(false)
      })
  }

  return (
    <>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          {children}
          <Button type="submit" fullWidth loading={loading}>
            Enviar código
          </Button>
          <Button variant="outline" fullWidth loading={loading} onClick={() => onCancel?.()}>
            Cancelar
          </Button>
        </Stack>
      </form>
    </>
  )
}
